import { Route, Routes } from 'react-router-dom';
import AwardsTable from './AwardsTable'
import CreateEditAwardMobile from './CreateEditAwardMobile'

export const AwardsPage = () => {
  return (
    <Routes>
      <Route index element={<AwardsTable />} />
      <Route path="create" element={<CreateEditAwardMobile />} />
      <Route path=':id/edit' element={<CreateEditAwardMobile />} />
    </Routes>
  )
}

export default AwardsPage;